import { render } from "./ReportDriverRanking.vue?vue&type=template&id=034f826f"
import script from "./ReportDriverRanking.vue?vue&type=script&lang=js"
export * from "./ReportDriverRanking.vue?vue&type=script&lang=js"
script.render = render

export default script